<template>
  <Menu as="div" class="relative">
    <MenuButton class="-m-1.5 flex items-center p-1.5">
      <span class="sr-only">Open user menu</span>
      <img
        v-if="authUser.small_photo_url"
        class="h-8 w-8 rounded-full bg-neutral-50 object-cover"
        :src="authUser.small_photo_url"
        alt="" />
      <div
        v-else
        class="h-8 w-8 rounded-full bg-accent-500 text-white text-sm font-semibold flex items-center justify-center">
        {{ initials }}
      </div>
      <span class="hidden lg:flex lg:items-center ml-4">
        <div class="flex flex-col items-end">
          <span class="text-sm font-semibold leading-6 text-black dark:text-white" aria-hidden="true">
            {{ authUser.first_name }} {{ authUser.surname }}
          </span>
          <span class="text-xs">{{ selectedOffice?.name || 'Office not selected' }}</span>
        </div>
        <i class="fa-sharp fa-regular fa-chevron-down fa-fw ml-2 text-neutral-400" aria-hidden="true"></i>
      </span>
    </MenuButton>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95">
      <MenuItems
        class="absolute right-0 z-10 mt-2.5 origin-top-right rounded-md bg-white dark:bg-neutral-800 py-2 shadow-lg ring-1 ring-neutral-900/5 focus:outline-hidden">
        <NtHeaderMenuItem v-if="authOffices.length > 0" label="Change Office" @click="$refs.officeSwitcher.open()" />
        <NtHeaderMenuItem label="My Ecosystem" :href="ecosystemUrl" />
        <NtHeaderMenuItem label="My Account" to="/my-account" />
        <NtHeaderMenuItem label="Log Out" @click="logOut" />
      </MenuItems>
    </transition>
  </Menu>

  <NtOfficeSwitcher ref="officeSwitcher" />
</template>

<script>
import { useAuthStore } from '@/stores/auth'
import { Menu, MenuButton, MenuItems } from '@headlessui/vue'
import { mapActions, mapState } from 'pinia'
import NtHeaderMenuItem from './NtHeaderMenuItem.vue'
import NtOfficeSwitcher from './NtOfficeSwitcher.vue'
import { useSystemStore } from '@/stores/system'

export default {
  components: {
    Menu, // eslint-disable-line vue/no-reserved-component-names
    MenuButton,
    MenuItems,
    NtHeaderMenuItem,
    NtOfficeSwitcher
  },
  computed: {
    ...mapState(useAuthStore, ['authUser', 'selectedOffice', 'authOffices']),
    ...mapState(useSystemStore, ['hub']),
    ecosystemUrl() {
      return import.meta.env.VITE_ECOSYSTEM_URL
    },
    initials() {
      let output = ''
      if (this.authUser.first_name.length > 0) {
        output += this.authUser.first_name[0]
      }
      if (this.authUser.surname.length > 0) {
        output += this.authUser.surname[0]
      }
      return output.toUpperCase()
    }
  },
  methods: {
    ...mapActions(useAuthStore, ['logOut', 'switchOffice'])
  }
}
</script>
